package portalmodels

import kotlinx.serialization.Serializable

@Serializable
data class GenericResponseDTO(
    val message: String,
    val isError: Boolean = false
)